__turbopack_context__.v({
  "seeAllButton": "BenzingaBriefsBlock-module-scss-module__BSHw_W__seeAllButton",
  "wrapper": "BenzingaBriefsBlock-module-scss-module__BSHw_W__wrapper",
});
